import Skeleton from "@mui/material/Skeleton";

export default function SkeletonList() {
    return (
        <div>
            {Array.from({ length: 22 }).map((_, index) => (
                <Skeleton
                    key={index}
                    variant='rounded'
                    height={20}
                    sx={{
                        margin: "10px 14px",
                        borderRadius: "6px",
                        backgroundColor: "#F2F4F7",
                    }}
                />
            ))}
        </div>
    );
}
